import React from "react";
import { Button, Icon } from "react-materialize";
import FormFunc from "../../../utils/FormFunc";
// import Feature from "../../../utils/Feature";
import { useInfo } from "context/InfoContext";

export default function EmpEmploymentContent({
  boxName,
  userData,
  handleEvents,
}) {
  const { filters, filterData, storeFilters } = useInfo();
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign || userData?.user_sess?.isAdmin
      ? false
      : true;

  React.useEffect(() => {
    if (filters && (!Array.isArray(filters.employment) || filters.employment.length === 0)) {
      storeFilters({
        ...filters,
        employment: [{ employment_type: "", start_date: "", end_date: "" }],
      });
    }
  }, [filters, storeFilters]);

  return (
    <div key={"employment-content-" + boxName + "-" + filters.key_form}>
      <div
        className={boxName + " row"}
        style={{
          borderTop: "2px solid #dcdbdb",
          borderBottom: "2px solid #dcdbdb",
          padding: "25px 10px",
          marginTop: "10px",
        }}
      >
        <h3
          className="col s9"
          style={{ color: "#5a5a5a", marginBottom: "20px", paddingLeft: "0px" }}
        >
          Employment(s)
        </h3>
        {!isCannotEdit ? (
          <div
            key={"btn-add-employment"}
            className="col s3"
            style={{ paddingRight: "0px" }}
          >
            <Button
              className="light-blue accent-2"
              node="button"
              waves="light"
              small={true}
              style={{
                marginBottom: "20px",
                paddingLeft: "5px",
                paddingRight: "5px",
                float: "right",
              }}
              onClick={handleEvents.BtnAddEmployment.OnClick}
            >
              Employment
              <Icon left style={{ marginRight: "8px", fontSize: "1.3rem" }}>
                add
              </Icon>
            </Button>
          </div>
        ) : (
          ""
        )}
        <EmpEmploymentSubContent
          filters={filters}
          filterData={filterData}
          isCannotEdit={isCannotEdit}
          handleEvents={handleEvents}
        />
        {!isCannotEdit ? (
          <>
            <div key={"info-employment"} className="col s12">
              <i
                className="small material-icons textcolor-green"
                style={{ fontSize: "13px", float: "left" }}
              >
                info
              </i>
              <span
                style={{ fontSize: "10px", marginLeft: "5px", float: "left" }}
              >
                When adding new employment type, start and end date fields will
                be added automaticly.
              </span>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

const EmpEmploymentSubContent = ({ filters, filterData, isCannotEdit, handleEvents }) => {
  const employments = filters?.employment ?? [];
  const renderEmployments =
    employments.length > 0
      ? employments
      : [{ employment_type: "", start_date: "", end_date: "" }];
  const n = renderEmployments.length;
  const elements = [];
  for (let index = n - 1; index >= 0; index--) {
    const item = renderEmployments[index];
    const canDelete = !isCannotEdit && employments.length > 1 && index > 0;
    elements.push(
      <div
        key={"employment-" + index}
        className="col s12"
        style={{
          border: "1px dashed #dcdbdb",
          padding: "20px 10px 5px 10px",
          borderRadius: "12px",
          marginBottom: "20px",
        }}
      >
        <FormFunc.SingleSelect
          data={{
            id: "employment_type_" + index,
            name: "employment_type",
            label: "Employment Type*",
            options: filterData.data.employmenttypes,
            addClass: "col s5",
            optionName: "emp_type_name",
            optionValue: "emp_type_name",
            optionTitle: "---",
            defaultValue: item["employment_type"],
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.InputDate
          data={{
            id: "start_date_" + index,
            name: "start_date",
            label: "Employment Start Date*",
            addClass: "col s3",
            defaultValue: item["start_date"],
            required: true,
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        <FormFunc.InputDate
          data={{
            id: "end_date_" + index,
            name: "end_date",
            label: "Employment End Date",
            addClass: "col " + (canDelete ? "s3" : "s4"),
            defaultValue: item["end_date"],
            disabled: isCannotEdit,
          }}
          events={handleEvents}
        />
        {canDelete ? (
          <div className="col s1">
            <Button
              className="red accent-2"
              floating
              node="button"
              waves="light"
              icon={<Icon>delete</Icon>}
              style={{ marginTop: "25px", float: "right" }}
              index={index}
              onClick={handleEvents.BtnDeleteEmployment.OnClick}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
  return elements;
};
